<template lang='pug'>
  v-card.fontText(class="mx-auto" max-width="580" align-center raised )
    v-list-item(three-line)
      v-list-item-content(style="margin-left: 30px;" )
        div(class="row")
          div(class="col-7")
            h2.fontTitle(style="margin-top: 38px;" ) Compra Exitosa
          div(class="col-5")
            img(
              :src="brand.logo"
              width="200"
              style="margin-right: 100px;"
            )
        v-list-tile-content(class="align-content-center")
          v-list-item
            p(class="font-weight-bold") Llegará a su correo el comprobante de este pago
        v-list-item-subtitle
          v-row
            v-col(cols="5" class="font-weight-bold")
              p Nombre Curso:
            v-col(cols="7")
              p {{ transactionData.itemsDescription }}
        v-list-item-subtitle
          v-row
            v-col(cols="5" class="font-weight-bold")
              p Nombre:
              p Rut:
            v-col(cols="7")
              p {{ userName }} {{ userLastName }}
              p {{ userRut }}
        v-list-item-content(v-if="transactionData.registrationType === 'EMPRESA'")
          v-list-item-subtitle
            v-row
              v-col(cols="5" class="font-weight-bold")
                p Empresa:
                p Rut Empresa:
                p Giro Empresa:
                p Dirección Empresa:
              v-col(cols="7")
                p {{ transactionData.enterpriseName }}
                p {{ transactionData.enterpriseRut }}
                p {{ transactionData.enterpriseBusinessActivity }}
                p {{ transactionData.enterpriseAddress }}
        v-list-item-subtitle
          v-row
            v-col(cols="5" class="font-weight-bold")
              p Transacción Nº:
              p(v-if="transactionResult.discount !== 0") Valor Curso:
              p(v-if="transactionResult.discount !== 0") Descuento:
              p Total Pagado:
              p Código de autorización:
              p Fecha de la transacción:
              p Tipo de pago:
              p(v-if="transactionResult.paymentType !== 'VN' && transactionResult.paymentType !== 'VD' && transactionResult.paymentType !== 'VP'") Monto Cuota:
              p(v-if="transactionResult.paymentType !== 'VD' && transactionResult.paymentType !== 'VP'") Cantidad de cuotas:
              p Tarjeta:
            v-col(cols="7")
              p {{ transactionData.buyOrder }}
              p(v-if="transactionResult.discount !== 0") {{ this.formatCurrency(transactionResult.initialAmount) }} CLP
              p(v-if="transactionResult.discount !== 0") {{ transactionResult.discount }}% ({{ formatCurrency(transactionResult.discountMount) }} CLP)
              p {{ transactionData.amount }} {{transactionData.currency}}
              p {{ transactionData.authorizationCode }}
              p {{ transactionData.transactionDate }}
              p {{ transactionData.paymentType }}
              p(v-if="transactionResult.paymentType !== 'VN' && transactionResult.paymentType !== 'VD' && transactionResult.paymentType !== 'VP'") {{ transactionData.sharesAmount }} {{transactionData.currency}}
              p(v-if="transactionResult.paymentType !== 'VD' && transactionResult.paymentType !== 'VP'") {{ transactionData.sharesNumber }}
              p {{ transactionData.cardNumber }}
    v-card-actions
      v-btn(rounded color="#81C41D" dark block @click="goBack()") Volver
    v-card-actions
        v-btn(rounded color="grey lighten-1" dark block @click="printWindow()") Imprimir comprobante

</template>

<script>
import brand from '../../utils/brand'
export default {
  props: {
    transactionResult: { required: true }
  },
  data () {
    return {
      brand,
      transactionData: {
        paymentStatus: '',
        buyOrder: null,
        amount: null,
        currency: '',
        authorizationCode: null,
        paymentType: '',
        transactionDate: null,
        sharesAmount: null,
        sharesNumber: null,
        cardNumber: null,
        itemsDescription: '',
        courseName: '',
        enterpriseName: '',
        enterpriseRut: '',
        enterpriseBusinessActivity: '',
        enterpriseAddress: '',
        registrationType: ''
      },
      userName: '',
      userLastName: '',
      userRut: ''
    }
  },
  methods: {
    goBack () {
      window.location.href = brand.homeUrl
    },
    printWindow () {
      return window.print()
    },
    checkPaymentType () {
      if (this.transactionResult.paymentType === 'VC' || this.transactionResult.paymentType === 'VN' || this.transactionResult.paymentType === 'SI' ||
      this.transactionResult.paymentType === 'S2' || this.transactionResult.paymentType === 'NC') {
        this.transactionData.paymentType = 'Tarjeta de Crédito'
      } else {
        if (this.transactionResult.paymentType === 'VD') {
          this.transactionData.paymentType = 'Tarjeta de Débito'
        } else {
          if (this.transactionResult.paymentType === 'VP') {
            this.transactionData.paymentType = 'Tarjeta de Prepago'
          }
        }
      }
    },
    formatDate (date) {
      // Transbank format date 'YYYY-MM-DDTHH:mm:ss.sssZ'
      const substringDate = date.substring(0, 10)
      const formatDate = substringDate.split('-').reverse().join('/')
      return formatDate
    },
    formatCurrency (amount) {
      const formatAmount = new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(amount)
      return formatAmount
    },
    setTransactionData () {
      this.transactionData.paymentStatus = this.transactionResult.paymentStatus
      this.transactionData.buyOrder = this.transactionResult.buyOrder
      this.transactionData.amount = this.formatCurrency(this.transactionResult.amount)
      this.transactionData.currency = this.transactionResult.currency
      this.transactionData.authorizationCode = this.transactionResult.authorizationCode
      this.transactionData.transactionDate = this.formatDate(this.transactionResult.transactionDate)
      this.transactionData.sharesAmount = this.formatCurrency(this.transactionResult.sharesAmount)
      this.transactionData.sharesNumber = this.transactionResult.sharesNumber
      this.transactionData.cardNumber = this.transactionResult.cardNumber
      this.transactionData.itemsDescription = this.transactionResult.courseName
      this.transactionData.enterpriseAddress = this.transactionResult.enterpriseAddress
      this.transactionData.enterpriseName = this.transactionResult.enterpriseName
      this.transactionData.enterpriseRut = this.transactionResult.enterpriseRut
      this.transactionData.enterpriseBusinessActivity = this.transactionResult.enterpriseBusinessActivity
      this.transactionData.registrationType = this.transactionResult.registrationType
      this.userName = this.transactionResult.userName
      this.userLastName = this.transactionResult.userLastname
      this.userRut = this.transactionResult.userRut
      this.checkPaymentType()
    }
  },
  mounted () {
    this.setTransactionData()
  }
}
</script>

<style lang="stylus">
.fontText{
  font-family: "Montserrat"
}
.fontTitle{
  font-family: "Montserrat-SemiBold"
}
</style>
